import { useLazyGetSumsubVerificationTokenRequestQuery } from '@features/api/userSlice';
import SumsubWebSdk from '@sumsub/websdk-react';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useNavigate, useParams } from 'react-router-dom';
import InvestmentFooter from '../InvestmentFooter/InvestmentFooter';
import { Steps } from '../Progress/Progress.types';
import { Container } from './IdentityVerification.styles';
import { Steps as ProgressSteps } from '../Progress/Progress.types';
import WithUser, { WithUserProps } from '@HOCs/withUser';

const APPLICANT_STATUS_KEY = 'idCheck.onApplicantStatusChanged';

const IdentityVerification: React.FC<WithUserProps> = ({
  refetchUser,
  user,
}) => {
  const navigate = useNavigate();
  const intl = useIntl();
  const { productId } = useParams();

  const [isApproved, setIsApproved] = useState(false);

  const [getSumsubVerificationToken, { data }] =
    useLazyGetSumsubVerificationTokenRequestQuery();
  const accessToken = data?.token;

  useEffect(() => {
    getSumsubVerificationToken({ verificationType: 'IDV' });
  }, [getSumsubVerificationToken]);

  useEffect(() => {
    if (accessToken && !user.personalDetailsLocked) refetchUser();
  }, [accessToken, user, refetchUser]);

  const handleMessage = (event: string, payload: any) => {
    if (event === APPLICANT_STATUS_KEY) {
      const { reviewStatus, reviewResult } = payload || {};

      const isApproved =
        reviewStatus === 'completed' && reviewResult?.reviewAnswer === 'GREEN';

      setIsApproved(isApproved);
    }
  };

  const onSubmit = async () => {
    navigate(`/investment-subscription/${productId}/progress`, {
      state: {
        completedSteps: [Steps.Details, Steps.IdentityVerification],
        progress: 8,
      },
      replace: true,
    });
  };

  if (!accessToken) return <></>;
  return (
    <Container>
      <SumsubWebSdk
        style={{
          width: '100%',
          maxHeight: 'calc(100vh - 200px)',
          overflow: 'auto',
        }}
        accessToken={accessToken}
        expirationHandler={async () => {
          const { token } = await getSumsubVerificationToken({
            verificationType: 'IDV',
          }).unwrap();
          return token;
        }}
        config={{
          uiConf: {
            customCss: window.parent.location.origin + '/VerifyProfile.css',
          },
          lang: 'en',
        }}
        options={{}}
        onMessage={handleMessage}
      />
      <InvestmentFooter
        secondaryButton={{
          title: intl.formatMessage({
            id: 'misc.previous',
          }),
          onClick: () =>
            navigate(
              `/investment-subscription/${productId}/identity-verification-intro`,
              {
                state: {
                  completedSteps: [ProgressSteps.Details],
                  progress: 7,
                },
                replace: true,
              }
            ),
        }}
        primaryButton={{
          title: intl.formatMessage({
            id: 'misc.next',
          }),
          disabled: !isApproved,
          onClick: onSubmit,
        }}
      />
    </Container>
  );
};

export default WithUser(IdentityVerification);
